import { type ObjectMode } from '@databases/types';
import {
  type Database,
  DatabaseFieldType,
  type DatabaseValue
} from '@databases/types/database';
import { createField, getExistingDatabase } from '@databases/utils/database/utils';

import { databasesToContentId } from './constants.ts';

export const databaseWithTagField = (): Database<ObjectMode.EXISTING> => {
  const database = getExistingDatabase({
    contentId: databasesToContentId['databaseWithTagField'],
    databaseName: 'Database with tag field',
    entryCount: 2
  });
  const tagField = createField(DatabaseFieldType.SELECT, {
    id: 'tag-field',
    name: 'Priority'
  });
  const secondTagField = createField(DatabaseFieldType.SELECT, {
    id: 'second-tag-field',
    name: 'Severity'
  });
  const lowOption = {
    color: 'greenLight' as const,
    id: 'low',
    label: 'Low'
  };
  const mediumOption = {
    color: 'yellowLight' as const,
    id: 'medium',
    label: 'Medium'
  };
  const highOption = {
    color: 'redLight' as const,
    id: 'high',
    label: 'High'
  };
  const selectValue = (
    optionId: string
  ): DatabaseValue<DatabaseFieldType.SELECT, object> => ({
    type: DatabaseFieldType.SELECT,
    value: [optionId]
  });

  return {
    ...database,
    fields: [tagField.id, secondTagField.id],
    fieldsById: {
      [tagField.id]: {
        ...tagField,
        settings: {
          ...tagField.settings,
          multi: false,
          selectOptions: [mediumOption]
        }
      },
      [secondTagField.id]: {
        ...secondTagField,
        settings: {
          ...secondTagField.settings,
          multi: false,
          selectOptions: [lowOption, mediumOption, highOption]
        }
      }
    },
    entriesById: Object.fromEntries(
      database.entries.map((entryId, index) => [
        entryId,
        {
          ...database.entriesById[entryId],
          values: {
            [tagField.id]: selectValue(mediumOption.id),
            [secondTagField.id]: selectValue(index === 0 ? highOption.id : lowOption.id)
          }
        }
      ])
    )
  };
};
